import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton, Tooltip } from '@dixa/lib-shared-habla';
import { useCallback } from 'react';
import { appActions } from 'app/app.actions';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
/** Represents the edit action of a custom attributes table row item. */
export const EditAction = ({ attribute }) => {
    const dispatch = useAppDispatch();
    const handleClick = useCallback(() => {
        dispatch(appActions.showModal({
            modal: {
                type: 'settings:customAttribute',
                arg: { entityId: 'conversation', mode: 'edit', attribute },
            },
        }));
    }, [dispatch, attribute]);
    return (_jsx(Tooltip, Object.assign({ content: "Edit", dark: true }, { children: _jsx(IconButton, { icon: "pen", variant: "tertiary", onClick: handleClick }) })));
};
